import { EditOutlined } from '@ant-design/icons';
import { useMemoizedFn, useMount, useToggle } from 'ahooks';
import { Button, FormProps, Modal } from 'antd';
import ShopeeShopType, { regionOptions } from './ShopeeShopType';
import { useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { ShopTypeEnum } from './ShopeeCNSCGuide';
import { ShopeeAuthShopParams } from './ShopeeShopAuthWay';
import { useGetRegionLabel } from 'hooks/business/useRegion';

interface StoreInfoProps {
  form: FormProps['form'];
  shopeeAuthParams?: ShopeeAuthShopParams;
  onChange?: (value: any) => void;
}

export const StoreInfo = (props: StoreInfoProps) => {
  const { form, shopeeAuthParams, onChange } = props;
  const { t } = useTranslate();
  const getRegionLabel = useGetRegionLabel();
  const [visible, { toggle }] = useToggle(false);

  const [values, setValues] = useState<any>({
    storeType: shopeeAuthParams?.storeType ?? 'LOCAL',
    shopType: shopeeAuthParams?.shopType ?? 'Local',
    region: shopeeAuthParams?.region ?? 'ID',
  });

  const handleOk = useMemoizedFn(() => {
    let values = form?.getFieldsValue();
    const shopType = values?.shopType;
    if (shopType === ShopTypeEnum.Local) {
      values = {
        ...values,
        storeType: 'LOCAL',
      };
    } else {
      values = {
        ...values,
        storeType: 'CROSS',
      };
    }

    setValues(values);
    onChange?.(values);
    toggle();
  });

  const shopTypeText = useMemo(() => {
    const shopType = values?.shopType;
    if (shopType === ShopTypeEnum.Local) {
      return t('ViewShops.LOCAL');
    }
    if (shopType === ShopTypeEnum.Cross3PF) {
      return t('authShop.thirdPF店铺');
    }
    if (shopType === ShopTypeEnum.CrossOfficial) {
      return t('authShop.跨境店铺');
    }
    return '';
  }, [values, t]);

  useMount(() => {
    onChange?.(values);
  });

  return (
    <>
      <div className="flex gap-1 items-center">
        <span>{shopTypeText}</span>
        {regionOptions.includes(values?.region?.toUpperCase()) && (
          <span>{getRegionLabel(values?.region)}</span>
        )}
        <Button type="link" icon={<EditOutlined />} onClick={toggle}>
          {t('btn_modify')}
        </Button>
      </div>
      <Modal
        title={t('authShop.店铺信息')}
        width={680}
        visible={visible}
        onCancel={toggle}
        onOk={handleOk}
      >
        <ShopeeShopType form={form} showNext={false} />
      </Modal>
    </>
  );
};
